import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'; // 新版本推荐路径
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import 'element-plus/dist/index.css'
import router from './router'
//请求接口
import apiService from "./util/apiService.js"
//公共样式
import './reset.css'
const app = createApp(App)
app.config.globalProperties.apiService = apiService; // 将axios添加到全局属性中
//运单查询弹窗
// import { waybillNoQuery } from './components/module/waybillQuery/waybillQuery.js'
// app.config.globalProperties.waybillNoQuery = waybillNoQuery
//订单打印弹窗
// import orderPrint from './components/module/orderPrint/orderPrint.js'
// app.config.globalProperties.orderPrint = orderPrint
// 注册全局方法
// import orderPrint from './components/module/orderPrint/orderPrint.js'
// app.config.globalProperties.$modal = modalHelper;
//全局变量
// import modalPopup from "./components/module/modalPopup/index.js"
// app.config.globalProperties.modalPopup = modalPopup
//订单打印弹窗
import waybillPrintPopup from './components/module/waybillPrintPopup/index.js'
app.config.globalProperties.waybillPrintPopup = waybillPrintPopup
import waybillQueryPopup from "./components/module/waybillQueryPopup/index.js"
app.config.globalProperties.waybillQueryPopup = waybillQueryPopup
//百度地图
import BaiduMap from 'vue-baidu-map-3x'
//全局变量
import global from "@/util/global.js"
app.config.globalProperties.global = global
//全局方法
import common from "./util/common.js"
app.config.globalProperties.common = common; 
//防抖处理，避免运单查询页面element某些组件出现报错，参考https://blog.csdn.net/m0_48300767/article/details/142468832
import { debounce } from "lodash";
const resizeObserver  = (window).ResizeObserver;
(window).ResizeObserver = class ResizeObserver extends resizeObserver  {
  constructor(callback) {
    callback = debounce(callback, 100);
    super(callback);
  }
};
//
app.use(router)
app.use(BaiduMap,{ak:'fXwgHBEgNI3oKCdg8l0934NYeXrTwOeg'})
//注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// 全局配置语言为中文
app.use(ElementPlus, { locale: zhCn ,size:"small"})

app.mount('#app')
